import { useTranslation } from "react-i18next";

import { dashboardRoutes } from "modules/dashboard";

import { PageError } from "../components/PageError";
import { PageWrapper } from "../components/PageWrapper";
import { COMMON_TRANSLATION_KEYS } from "../constants/commonTranslationsKeys";

import type { ReactNode } from "react";

export interface Page403Props {
  buttonLabel?: ReactNode;
  goBackLink?: string;
}

export function Page403({ buttonLabel, goBackLink }: Page403Props) {
  const { t } = useTranslation("common");

  return (
    <PageWrapper>
      <PageError
        title={t(COMMON_TRANSLATION_KEYS.forbiddenError)}
        description={t(COMMON_TRANSLATION_KEYS.youDoNotHavePermissions)}
        goBackLink={goBackLink ?? dashboardRoutes.path}
        buttonLabel={
          buttonLabel ?? t(COMMON_TRANSLATION_KEYS.returnToDashboard)
        }
      />
    </PageWrapper>
  );
}
